import React, { useState } from 'react'
import Header from '../../components/common/Header'
import ViewAllProfile from '../../components/System/ViewAllProfile'
import { Container } from '../../components/common/System'
import ViewProfileSearch from '../../components/System/ViewProfileSearch'
import { useProfileApi } from '../../hooks/useProfile'

const ViewProfilePage = () => {
    const [major, setMajor] = useState('')
    const [lv, setLv] = useState('')
    const [section, setSection] = useState('')

    const search = {'major': major, 'lv': lv, 'section': section}
    const {isLoading, refetch, data} = useProfileApi(search)

    const formMajorHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      const target = e.currentTarget as HTMLButtonElement
      setMajor(target.value)
    }

    const formLvHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setLv(e.target.value)
  }
    const formSectionHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setSection(e.target.value)
  }
    
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      console.log(search)
      refetch()
    }
  
  return (
    <>
        <Header />
        <Container>
          <ViewProfileSearch
            major = {major}
            lv= {lv}
            section= {section}
            formMajorHandler = {formMajorHandler}
            formLvHandler = {formLvHandler}
            formSectionHandler = {formSectionHandler}
            handleSubmit = {handleSubmit}
          />
          {isLoading?
           <h3>Loading</h3>
          : <ViewAllProfile
              data = {data}
            />
          }
        </Container>
    </>
  )
}

export default ViewProfilePage